import ComplaintProduct from './ComplaintProduct'

export default ComplaintProduct
